import React, { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";

import { getKPIsInnovationCategory } from "modules/reporting/fordReports/kpis/store/kpis.actions";
import { makeActualScoreCardFilterData } from "modules/reporting/fordReports/utils";
import LoadingComponent from "modules/primitives/loading/loading.component";
import genericStyles from '../../styles.module.scss';
import ReportingDoughnutChart from "modules/reporting/components/reportingDoughnutChart";

const FordInnovationCategory = ({ innovationCategory, filters }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (!innovationCategory.data) {
      const makeFilters = makeActualScoreCardFilterData(filters);
      const payload = {
        enqueueSnackbar,
        data: makeFilters,
      };

      dispatch(getKPIsInnovationCategory(payload))
    }
  }, []);

  return (
    <div className={genericStyles.columnCard}>
      {
        innovationCategory.fetching ? (
          <LoadingComponent customText="Getting innovation category..." />
        ) : (
          <div className="d-flex flex-column">
            <span className={genericStyles.columnCardTitle}>Innovation Category</span>
            <div className="d-flex justify-content-center">
              <ReportingDoughnutChart
                chartData={{
                  chart_data: innovationCategory.data
                }}
                id="innovationCategory"
                instance="innovationCategory"
                selectedTags={[]}
                handleSegmentClick={() => {}}
                handleResetAll={() => {}}
                renderPieInstance
              />
            </div>
          </div>
        )
      }
    </div>
  );
};

export default React.memo(FordInnovationCategory);
